import { useState, useEffect } from 'react';

export default function Loader() {
  const [visible, setVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFadeOut(true), 1200);
    const remove = setTimeout(() => setVisible(false), 1700);
    return () => {
      clearTimeout(timer);
      clearTimeout(remove);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-background-50 transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-6">
        <div className="relative w-16 h-16">
          <div className="absolute inset-0 rounded-full border-2 border-accent-200 animate-ping opacity-60"></div>
          <div className="absolute inset-2 rounded-full border-2 border-accent-400 animate-spin-slow border-t-transparent"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <i className="ri-leaf-line text-2xl text-accent-500"></i>
          </div>
        </div>
        <span className="font-heading font-semibold text-foreground-600 text-sm tracking-wider animate-pulse">
          Naturalle
        </span>
      </div>
    </div>
  );
}